
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { User, LogOut } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

const Header = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  
  return (
    <header className="bg-gray-800 text-white shadow-md sticky top-0 z-10">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <div className="flex-1"></div>
        
        <div className="flex justify-center">
          <Link to={user ? "/dashboard" : "/"} className="flex items-center group">
            <img 
              src="/lovable-uploads/39686db0-4967-4556-a4f9-65cbf5776672.png" 
              alt="SunJob Technology" 
              className="h-16 w-auto" 
            />
          </Link>
        </div>

        <div className="flex-1 flex justify-end">
          {user ? (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" className="relative flex items-center text-white hover:bg-gray-700">
                  <Avatar className="h-8 w-8 mr-2 border border-white/20">
                    <AvatarImage src={user.profilePicture || ""} alt={user.nome} />
                    <AvatarFallback className="bg-gray-600 text-white text-xs">
                      {user.nome.substring(0, 2).toUpperCase()}
                    </AvatarFallback>
                  </Avatar>
                  <span className="mr-2 hidden sm:inline">{user.nome}</span>
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-56">
                <DropdownMenuLabel>{user.email}</DropdownMenuLabel>
                <DropdownMenuSeparator />
                <Link to="/perfil">
                  <DropdownMenuItem>
                    <User className="mr-2 h-4 w-4" />
                    <span>Meu Perfil</span>
                  </DropdownMenuItem>
                </Link>
                
                {/* Link to Users page for admins */}
                <Link to="/usuarios">
                  <DropdownMenuItem>
                    <User className="mr-2 h-4 w-4" />
                    <span>Gerenciar Usuários</span>
                  </DropdownMenuItem>
                </Link>
                
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={logout}>
                  <LogOut className="mr-2 h-4 w-4" />
                  <span>Sair</span>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          ) : (
            !isHomePage && (
              <Link to="/login">
                <Button
                  variant="ghost"
                  className="bg-gray-700 hover:bg-gray-600 text-white rounded-full px-4 py-2 flex items-center gap-2 transition-all duration-300"
                >
                  <LogOut className="h-4 w-4" />
                  <span className="inline-block">Entrar</span>
                </Button>
              </Link>
            )
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
